import { HANDLE_EXPENSE, RESET } from '../actions';
import moment from 'moment';

const initialState = {
    expense: [],
    vehicleSelected: "",
    employeeSelected: "",
    expenseType: "",
    startDateFilter: moment().format("YYYY-MM-DD"),
    endDateFilter: moment().format("YYYY-MM-DD"),
};

const Expense = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_EXPENSE:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState
        default:
            return state;
    }
};

export default Expense;